import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../../firestore-DB-config/firebase-config"; // Adjust the import based on your setup
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";

// List of available icons for the dropdown
const iconOptions = [
  { label: "Search", value: "Search" },
  { label: "Home", value: "Home" },
  { label: "Bed", value: "Bed" },
];

const AddServiceForm = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [icon, setIcon] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Ensure that all fields are filled
    if (title && description && icon) {
      try {
        // Add a new document to the "services" collection in Firestore
        await addDoc(collection(db, "services"), {
          title,
          description,
          icon,
        });
        // Clear the form after submission
        setTitle("");
        setDescription("");
        setIcon("");
        alert("Service added successfully!");
      } catch (error) {
        console.error("Error adding service: ", error);
        alert("Failed to add service. Try again.");
      }
    } else {
      alert("Please fill in all fields.");
    }
  };

  return (
    <>
      <Header />
      <Container
        maxWidth="sm"
        sx={{
          my: { xs: 4, md: 8 }, // Adjust vertical spacing based on screen size
          px: { xs: 2, md: 4 }, // Adjust horizontal padding
          textAlign: { xs: "center", md: "left" }, // Center align on small screens
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontSize: { xs: "1.5rem", md: "2rem" }, fontWeight: "600" }} // Responsive typography
        >
          Add New Service
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: { xs: 2, md: 4 } }} // Responsive margin-top
        >
          <TextField
            label="Service Title"
            fullWidth
            variant="outlined"
            margin="normal"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            sx={{ borderRadius: "12px" }} // Rounded corners
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            margin="normal"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            sx={{ borderRadius: "12px" }}
          />
          <TextField
            select
            label="Select Icon"
            fullWidth
            variant="outlined"
            margin="normal"
            value={icon}
            onChange={(e) => setIcon(e.target.value)}
            required
            sx={{ borderRadius: "12px" }}
          >
            {iconOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{
              mt: 2,
              borderRadius: "12px",
              width: { xs: "100%", md: "auto" }, // Full width on small screens
              textTransform: "none", // Prevent uppercase button text
            }}
            fullWidth
          >
            Add Service
          </Button>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default AddServiceForm;
